module.exports = __webpack_public_path__ + "static/media/workplace1.04689c5a.jpg";